import { render, staticRenderFns } from "./BpaRaasIcon.vue?vue&type=template&id=e10d44cc"
import script from "./BpaRaasIcon.vue?vue&type=script&lang=js"
export * from "./BpaRaasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports